import { render, staticRenderFns } from "./TempNotification.vue?vue&type=template&id=0d78a6f9&scoped=true&"
import script from "./TempNotification.vue?vue&type=script&lang=js&"
export * from "./TempNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d78a6f9",
  null
  
)

export default component.exports